import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Components/Home";
// import RegistrationForm from "./Components/RegistrationForm";
import Congratulations from "./Components/Congratulations";
import ProtectedRoute from "./Service/ProtectedRoute";
// import SubmissionForm from "./Components/SubmissionForm";

function App() {
  return (
    <Router>
        <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/register" element={<RegistrationForm />} /> */}
            <Route path="/congratulation" element={<ProtectedRoute element={<Congratulations />} />} />
            {/* <Route path="/submission" element={<SubmissionForm />} /> */}
            <Route path="*" element={<Home/>} />
        </Routes>
    </Router>
  );
}

export default App;
